import React, { useState, useContext, useRef, useEffect, useCallback, useMemo } from 'react';
import { colors } from '#utils';
import PropTypes from 'prop-types';

const colorsKeys = Object.keys(colors);

const ColorContext = React.createContext();

const useColor = () => {
    return useContext(ColorContext);
};

const ColorProvider = ({ children }) => {
    const [index, setIndex] = useState(3);
    const indexRef = useRef(3);

    useEffect(() => {
        indexRef.current = index;
    }, [index]);

    const nextKey = useCallback(() => {
        if (!colorsKeys.length) return undefined;

        const currentIndex = indexRef.current;
        const nextIndex = (currentIndex + 1) % colorsKeys.length;

        indexRef.current = nextIndex;
        setIndex(nextIndex);

        return colorsKeys[nextIndex];
    }, []);

    const nextValue = useCallback(() => {
        return colors[nextKey()];
    }, [nextKey]);

    const value = useMemo(() => ({ nextKey, nextValue }), [nextKey, nextValue]);

    return <ColorContext.Provider value={value}>{children}</ColorContext.Provider>;
};

ColorProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export { useColor };
export default ColorProvider;
